/* tslint:disable */

declare var Object: any;
export interface MeetingInterface {
  "sfdcId"?: string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Name"?: string;
  "OwnerId"?: string;
  "End_Datetime__c"?: Date;
  "End_Datetime_GMT__c"?: Date;
  "Interval__c"?: string;
  "IRON_ExtID__c"?: string;
  "Location__c"?: string;
  "Meeting_Description__c"?: string;
  "Meeting_Status__c"?: string;
  "Organizer__c"?: string;
  "Reminder__c"?: string;
  "Start_Datetime__c"?: Date;
  "Start_Datetime_GMT__c"?: Date;
  "TimeZone__c"?: string;
  "Topic_Subject__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class Meeting implements MeetingInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Name": string;
  "OwnerId": string;
  "End_Datetime__c": Date;
  "End_Datetime_GMT__c": Date;
  "Interval__c": string;
  "IRON_ExtID__c": string;
  "Location__c": string;
  "Meeting_Description__c": string;
  "Meeting_Status__c": string;
  "Organizer__c": string;
  "Reminder__c": string;
  "Start_Datetime__c": Date;
  "Start_Datetime_GMT__c": Date;
  "TimeZone__c": string;
  "Topic_Subject__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: MeetingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Meeting`.
   */
  public static getModelName() {
    return "Meeting";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Meeting for dynamic purposes.
  **/
  public static factory(data: MeetingInterface): Meeting{
    return new Meeting(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Meeting',
      plural: 'Meetings',
      path: 'Meetings',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "End_Datetime__c": {
          name: 'End_Datetime__c',
          type: 'Date'
        },
        "End_Datetime_GMT__c": {
          name: 'End_Datetime_GMT__c',
          type: 'Date'
        },
        "Interval__c": {
          name: 'Interval__c',
          type: 'string'
        },
        "IRON_ExtID__c": {
          name: 'IRON_ExtID__c',
          type: 'string'
        },
        "Location__c": {
          name: 'Location__c',
          type: 'string'
        },
        "Meeting_Description__c": {
          name: 'Meeting_Description__c',
          type: 'string'
        },
        "Meeting_Status__c": {
          name: 'Meeting_Status__c',
          type: 'string'
        },
        "Organizer__c": {
          name: 'Organizer__c',
          type: 'string'
        },
        "Reminder__c": {
          name: 'Reminder__c',
          type: 'string'
        },
        "Start_Datetime__c": {
          name: 'Start_Datetime__c',
          type: 'Date'
        },
        "Start_Datetime_GMT__c": {
          name: 'Start_Datetime_GMT__c',
          type: 'Date'
        },
        "TimeZone__c": {
          name: 'TimeZone__c',
          type: 'string'
        },
        "Topic_Subject__c": {
          name: 'Topic_Subject__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
